<p-card [header]="header">
  {{ content }}
  <ng-content></ng-content>
</p-card>
